import Avatar from '@mui/material/Avatar'
import ProfileIcon from '../icons/ProfileIcon'

interface UserAvatarProps {
  name?: string
  size?: number
}

const UserAvatar = ({ name, size = 32 }: UserAvatarProps) => (
  <Avatar
    aria-label={name ? `${name}'s profile` : 'User profile'}
    sx={{
      width: size,
      height: size,
      bgcolor: 'var(--tenant-color, #2d6a4f)',
      flexShrink: 0,
    }}
  >
    <ProfileIcon sx={{ fontSize: size * 0.65 }} />
  </Avatar>
)

export default UserAvatar
